import ArticleQuantityInput from './CartArticleQuantityInput';

export default { ArticleQuantityInput };
